import * as actionCreators from '@atlassian/jira-common-services/src/callback-registry';
import type { Actions } from './types';

const actions: Actions = {
	add:
		(cb) =>
		({ dispatch }) =>
			dispatch(actionCreators.add('callbacks', cb)),
	remove:
		(cb) =>
		({ dispatch }) =>
			dispatch(actionCreators.remove('callbacks', cb)),
	clear:
		() =>
		({ dispatch }) =>
			dispatch(actionCreators.clear('callbacks')),
	run:
		(...args) =>
		({ dispatch }) =>
			dispatch(actionCreators.run('callbacks', ...args)),
};

export default actions;
